var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kee-breadcrumb" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(_vm._s(_vm.$t("home"))),
          ]),
          _vm._l(_vm.list, function (item) {
            return _c(
              "el-breadcrumb-item",
              { key: item.path, attrs: { to: { path: item.path } } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t(item.title || item.meta.title)) +
                    "\n    "
                ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }